module.exports = __webpack_public_path__ + "img/research_3.67422114.jpg";